<div class="layout-container" #layoutContainer>
  <div class="app" [ngClass]="{'big-background': bigHeader, 'none-background': navbarBackgroundBlue, 'gallery-header': galleryHeader, 'mobile-menu': isMobileMenu}">
    <app-header *ngIf="showHeader" [navbarBackgroundBlue]="navbarBackgroundBlue"></app-header>
    <main>
      <router-outlet></router-outlet>
    </main>
    <app-footer *ngIf="showFooter"></app-footer>
  </div>
</div>
